import { useCallback } from 'react';
import { useNavigation } from '@react-navigation/native';
import { useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { useModuleAndTaskSelectionState } from '@/common/context/AppStateStore';
import { useDialog } from '@/common/context/DialogContext';

import {
  completeModuleSubmissionUx,
  type CompleteModuleSubmissionUxParams,
} from './completeModuleSubmissionUx';

/**
 * Hook wrapper for {@link completeModuleSubmissionUx} with navigation, dialog,
 * and query-client dependencies wired from app context.
 */
export function useCompleteModuleSubmissionUx() {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const navigation = useNavigation<any>();
  const queryClient = useQueryClient();
  const { clearSelection } = useModuleAndTaskSelectionState();
  const { showDialog, showToastMessage } = useDialog();
  const { t } = useTranslation();

  return useCallback((params: CompleteModuleSubmissionUxParams) => {
    completeModuleSubmissionUx({
      navigation,
      queryClient,
      clearSelection,
      showDialog,
      showToastMessage,
      t,
    }, params);
  }, [navigation, queryClient, clearSelection, showDialog, showToastMessage, t]);
}
